import { render, staticRenderFns } from "./recommendBind.vue?vue&type=template&id=267cd166&scoped=true&"
import script from "./recommendBind.vue?vue&type=script&lang=js&"
export * from "./recommendBind.vue?vue&type=script&lang=js&"
import style0 from "./recommendBind.vue?vue&type=style&index=0&lang=less&"
import style1 from "./recommendBind.vue?vue&type=style&index=1&id=267cd166&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267cd166",
  null
  
)

export default component.exports